export function UrlConverter(inputUrl) {
  try {
    const parsed = new URL(inputUrl);

    // Get only the first path segment
    const pathname = parsed.pathname.split("/").filter(Boolean);
    const firstPath = pathname.length > 0 ? `/${pathname[0]}` : "";

    // Final shortened URL (with protocol & host)
    return `${parsed.protocol}//${parsed.host}${firstPath}`;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null; // return null if invalid
  }
}
